import color from 'color';
import { append, compose, flip, identity, ifElse, concat, path, pathEq, curry, gte, gt } from 'ramda';
import { renderWhenTrue } from '../shared/utils/rendering';
import { sizesOrdered } from './media';

const ensureArray = ifElse(Array.isArray, identity, flip(append)([]));

export const fromTheme = compose(
  path,
  concat(['theme']),
  ensureArray
);

export const themeColor = compose(
  fromTheme,
  concat(['colors']),
  ensureArray
);

export const themeGradient = compose(
  fromTheme,
  concat(['gradient']),
  ensureArray
);

export const themeBorder = compose(
  fromTheme,
  concat(['border']),
  ensureArray
);

export const themeShadow = compose(
  fromTheme,
  concat(['shadow']),
  ensureArray
);

export const themeZIndex = compose(
  fromTheme,
  concat(['zIndexes']),
  ensureArray
);

export const whenThemePropEqualsTrue = curry((propName, fn) =>
  compose(
    renderWhenTrue(fn),
    pathEq(['theme', propName], true)
  )
);

export const whenThemePropEqualsExpectedValue = curry((propName, expectedValue, fn) =>
  compose(
    renderWhenTrue(fn),
    pathEq(['theme', propName], expectedValue)
  )
);

export const themeColorWithOpacity = (colorId, alpha) =>
  compose(
    value =>
      color(value)
        .alpha(alpha)
        .string(),
    themeColor(colorId)
  );

export const themeFont = compose(
  fromTheme,
  concat(['fonts']),
  ensureArray
);

export const themeSize = compose(
  fromTheme,
  concat(['sizes']),
  ensureArray
);

export const activeBreakpoint = fromTheme('activeBreakpoint');

export const matchBreakpoint = (breakpoint, allowEqual = true) => props => {
  const currentBreakpoint = activeBreakpoint(props);
  const compare = allowEqual ? gte : gt;
  return compare(sizesOrdered.indexOf(currentBreakpoint), sizesOrdered.indexOf(breakpoint));
};
